module.exports = __webpack_public_path__ + "static/media/hand.c383eb35.png";